import { Button } from '@alifd/next';
import { Result, Spin } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';

import Tab from '@/components/UI/mobile/Tab';
import useService from '@/lib/hooks/useService';
import useUser from '@/lib/hooks/useUser';

import styles from './index.module.scss';

const SmartMailFrontDeskList = () => {
  const [showMailOpen, setShowMailOpen] = useState(false);
  const [tab, setTab] = useState(0);
  const [isDebounce, setIsDebounce] = useState(true);

  const { user } = useUser();

  // TODO: 資料庫格式未定義明確，因此record只能使用any型別，需等待後端定義格式後加上zod shcema
  const [mails, , , mailsIsLoading] = useService({
    collectionName: 'baEvent',
    query: {
      userId: user?._id,
      title: { $in: ['信箱投信', '信箱未關'] },
      $sort: {
        createdTime: -1,
      },
    },
  });

  const sendMailArr = mails?.filter((mail) => {
    if (tab === 0) {
      return mail.title === '信箱投信';
    }
    return mail.title === '信箱未關';
  });

  // TODO: 資料庫格式未定義明確，因此record只能使用any型別，需等待後端定義格式後加上zod shcema
  const [householdNumbers, , , householdNumbersIsLoading] = useService({
    collectionName: 'residentAccountNumbers',
    query: {
      householdNumber: { $in: user?.householdNumbers },
    },
  });

  const userMailNumber = householdNumbers?.[0]?.mailNumber;

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const checkShowContent = () => {
      setIsDebounce(true);
      timer = setTimeout(() => {
        if (!householdNumbersIsLoading && !mailsIsLoading) {
          setIsDebounce(false);
        } else {
          checkShowContent();
        }
      }, 1000);
    };
    checkShowContent();
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [householdNumbersIsLoading, mailsIsLoading]);

  return (
    <div className={styles.mobileSmartMail}>
      <div className={styles.mobileSmartMailBackground} />
      {isDebounce && <Result icon={<Spin size="large" />} title="讀取中..." />}
      {!isDebounce && !userMailNumber && (
        <Result status="warning" title="尚未設定智慧信箱，請與管理中心聯絡" />
      )}
      {!isDebounce && userMailNumber && (
        <>
          <div className={styles.mainBtnBox}>
            <Button
              id={styles.mainBtn}
              onClick={() => {
                Swal.fire({
                  title: `您確定要開啟信箱?`,
                  text: '請確認是否開啟信箱!!',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#BEBEBE',
                  confirmButtonText: '確定',
                  cancelButtonText: '取消',
                }).then((result) => {
                  if (result.isConfirmed) {
                    setShowMailOpen(true);
                    setTimeout(() => {
                      setShowMailOpen(false);
                    }, 3000);
                    axios(
                      `/ezcon/api/ba/event?事件名稱=開啟信箱&信箱=${userMailNumber}`,
                      {
                        method: 'GET',
                        headers: {
                          authorization: window.localStorage['feathers-jwt'],
                        },
                      }
                    )
                      .then((res) => {
                        console.log('==send openMailBox Success:', res);
                      })
                      .catch((error) => {
                        console.error('==send openMailBox fail:', error);
                      });
                  }
                });
              }}
            >
              開啟信箱
            </Button>
          </div>
          <div
            className={styles.showMailOpen}
            style={{ display: showMailOpen ? 'flex' : 'none' }}
          >
            <img
              className={styles.showMailImg}
              src="img/image_mail.svg"
              alt="圖片"
            />
          </div>
          <div className={styles.main} style={{ marginBottom: 10 }}>
            <Tab
              options={['信箱投信', '信箱未關']}
              value={tab}
              onChange={setTab}
            />
          </div>
          {sendMailArr.map((list, index) => {
            return (
              <div className={styles.main} key={index}>
                <div className={styles.flexItem}>
                  <div>
                    <h3>{list.title}</h3>
                  </div>
                  <div>
                    {moment(list.createdTime).format('YYYY/MM/DD HH:mm:ss')}
                  </div>
                </div>
                <hr className={styles.bcolor} />
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default SmartMailFrontDeskList;
